import shortid from "shortid"
import merge from "lodash.merge"
import Speedtest from "@frog/source/tests/utility/Speedtest.js"
import Geometry from "@frog/source/utility/Geometry.js"
import deepclone from "lodash.clonedeep"
import Objdict from "objdict"

import Unit from "@frog/source/models/Unit.js"
import Reactions from "@frog/source/models/Reactions.js"
import Selection from "@frog/source/models/admin/Selection.js"
import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import Delta from "@frog/source/models/Delta.js"
import InkDialogue from "@frog/source/utility/integration/InkDialogue.js"

import Dev from "@frog/source/models/admin/Dev.js"

// import worlds from "@frog/source/data/worlds.js"
const worlds = {}
// import chapters from "@frog/source/data/encounters/chapters.js" // imported for loading encounters.
import skills from "@frog/source/data/skills.js"
// import * as deathzone from "@frog/source/data/deathzone.js"
import Step from "@frog/source/models/Step.js"
import Random from "@frog/source/utility/Random.js"

const MAX_INFLUENCE = 200 // TODO: this is duped from Unit.js

function fill(percentage, digits = 3) {
    if(digits == 0) {
        return ""
    }
    let string = ""
    string += Math.round(percentage * Math.pow(10, digits - 1))
    while(string.length < digits) {
        string = "0" + string
    }
    return string
}

export default class Stage {
    static load({stage, player, hasPreparePhase, isRandomized, startingEncounter}) {
        stage = deepclone(stage)

        // if(stage.reference != undefined) {
        //     if(stages[stage.reference] == undefined) {
        //         throw "Could not find stage with reference " + stage.reference
        //     }
        //
        //     // TODO: Even if the stage is referenced, it should merge
        //     // any overriding child properties on top of the reference!
        //     // But it should do it intelligently, like merging units instead
        //     // of replacing units?
        //
        //     stage = stages[stage.reference]
        // }

        let units = []
        if(stage.units != undefined) {
            units = stage.units
        } else {
            units = units.concat(Object.values(stage.world.units))
        }

        stage.units = {}
        Objdict.forEach(Objdict.convert(units), (unit) => {
            if(unit.day != undefined
            && unit.day > player.day) {
                return
            }
            stage.units[unit.key] = Unit.instantiate({unit, player})
        })

        stage.player = Player.copy(player)

        // // Instantiate out-of-zone instances of every unit for repositioning during prepare phase
        // if(hasPreparePhase == true) {
        //     Object.values(player.party.units).forEach((unit) => {
        //         stage.units[unit.key] = Unit.instantiate({player, chapterParty, "unit": {
        //             "key": unit.key,
        //             "position": {"x": -10, "y": -10, "z": 0},
        //             "hasBeenRemoved": true,
        //         }})
        //     })
        // }

        // // TODO: THIS SHOULDN'T JUST NUKE IT, IT SHOULD MERGE
        // // IT WITH ANY CHANGES...? THE PROTOSTAGE HAS DECLARED.
        // // ALSO, WE SHOULD MOVE THIS TO A WORLD STATIC LOAD CLASS!
        // if(stage.world.reference != undefined) {
        //     if(worlds[stage.world.reference] == undefined) {
        //         throw new Error("Could not find world with reference " + stage.world.reference)
        //     }
        //     let mergedWorld = deepclone(worlds[stage.world.reference])
        //
        //     const alteredWorld = {"reference": stage.world.reference}
        //     mergedWorld = merge(mergedWorld, alteredWorld)
        //
        //     // if(stage.world.terrain != undefined) {
        //     //     // const alteredTerrain = stage.world.terrain.map((terrain, key) => {
        //     //     //     if(terrain.position == undefined) {
        //     //     //         throw "Could not instantiate terrain without position"
        //     //     //     }
        //     //     //     terrain.position = terrain.position
        //     //     //     terrain.shape = terrain.shape || "block"
        //     //     //     terrain.z = terrain.position.z // AREN'T WE OBSOLETING THIS?
        //     //     //     terrain.key = terrain.key || terrain.position.x + "x" + terrain.position.y
        //     //     //     return terrain
        //     //     // })
        //     //     // console.log(alteredTerrain, mergedWorld)
        //     //     // mergedWorld.terrain = Objdict.merge(mergedWorld.terrain, alteredTerrain)
        //     // }
        //     // MERGE IN MORE PROPERTIES, BUT DEEPLY!!
        //
        //     stage.world = mergedWorld
        // }
        Dev.havePlayunitsBeenModified = false

        if(stage.world.zones != undefined) {
            stage.encounters = stage.world.zones
            Object.values(stage.encounters).forEach((encounter) => {
                encounter.conditions = stage.conditions
                encounter.events = stage.events
            })
        }

        if(startingEncounter != undefined) {
            stage.currentEncounter = startingEncounter
        }
        else {
            stage.currentEncounter = "1" // TODO: how to define the default starting encounter?
        }
        stage.turn = {"number": 0, "affiliation": "good"}
        // stage.actionMark = 0
        // stage.zone = 0

        // stage.success = stage.success || {"type": "defeat-all-units"} // TODO: qualify this as the player's success?
        // stage.failure = stage.failure || {"type": "defeat-all-units"} // TODO: qualify this as the player's failure?

        // TODO: Even if a stage is passed, search it for properties
        // that need to be deserialized or defaulted like base stats on units!
        // Or maybe the stage is defined but the map is a reference.

        return stage
    }
    static findUnitAtPosition(stage, position, options) {
        return Stage.findUnitsByPosition(stage, position, options)[0]
    }
    static findUnitByPosition(stage, position, options = {}) {
        return Stage.findUnitsByPosition(stage, position, options)[0]
    }
    static findUnitsByPosition(stage, position, options = {}) {
        if(options.excludeUnitKey instanceof Array == false) {
            if(options.excludeUnitKey != undefined) {
                options.excludeUnitKey = [options.excludeUnitKey]
            } else {
                options.excludeUnitKey = []
            }
        }
        return Object.values(stage.units).filter((unit) => {
            if(unit.isDead) return false
            if(unit.hasBeenRemoved) return false
            if(options.excludeUnitKey.includes(unit.key)) return false
            if(unit.type == "zone" && Dev.inProtoMode == false) {
                if(!(options.includingSpawnZones && unit.type == "spawn-zone")
                || !options.includingZones) {
                    return false
                }
            }
            return unit.position.x == position.x
                && unit.position.y == position.y
                // && unit.position.z == position.z
        })
    }
    static findUnitInDirection(stage, position, direction, range) {
        let distance = 0
        let previousPosition = Geometry.add(position, {"x": 0, "y": 0})
        let nextPosition = Geometry.add(position, direction)

        while(Stage.hasCollision({stage, previousPosition, nextPosition, "options": {"isIgnoringLedges": true}}) == false) {
            distance += 1
            if(range != undefined && distance >= range.max) break
            vector = Geometry.multiply(direction, distance)
            previousPosition = Geometry.add(position, vector)
            nextPosition = Geometry.add(position, vector, direction)
        }

        // if(distance == 0) couldn't go far in any direction, but did find a direction
        if(World.hasCollision({
            "world": stage.world, previousPosition, nextPosition,
            "options": {"isIgnoringLedges": true},
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        }) == true) {
            // FOUND A COLLISION
        } else if(Stage.findUnitByPosition(stage, nextPosition) != undefined) {
            return Stage.findUnitByPosition(stage, nextPosition)
        }
    }
    // returns a collision raycast.
    // the positions are a raycast. the end position is the last good position before the collision position.
    // startPosition -----> endPosition || collisionPosition
    // can return no collision if a maxdistance is provided.
    // ignores any collision on the tile it is leaving from
    static findCollisionInDirection({stage, position, direction, maxdistance=Infinity, options}) {
        const ray = {
            "startPosition": position,
            "direction": direction,

            "endPosition": Geometry.copy(position),
            "vector": {"x": 0, "y": 0},
            "distance": 0,

            "positions": [], // THIS ONE INCLUDES THE COLLISION!!
            "castedPositions": [], // THIS ONE DOES NOT INCLUDE THE COLLISION, AND INCLUDES THE CAST START LOCATION
        }

        while(ray.distance < maxdistance) {
            const previousPosition = ray.endPosition
            const nextPosition = Geometry.add(ray.endPosition, ray.direction)
            ray.positions.push(nextPosition)
            ray.castedPositions.push(previousPosition)

            const collision = Stage.findCollision({stage, previousPosition, nextPosition, options})
            if(collision != undefined) {
                ray.collisionPosition = nextPosition
                ray.collision = collision
                break
            }

            ray.distance += 1
            ray.vector = Geometry.add(ray.vector, direction)
            ray.endPosition = Geometry.add(ray.endPosition, direction)

            if(ray.distance >= maxdistance) {
                ray.castedPositions.push(nextPosition)
                break
            }
        }

        return ray
    }
    static findCollision({stage, previousPosition, nextPosition, options}) {
        if(World.hasCollision({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        })) {
            return {"type": "world", "position": nextPosition}
        }
        const unit = Stage.findUnitByPosition(stage, nextPosition)
        if(unit != undefined) {
            return {"type": "unit", "position": nextPosition, "unit": unit}
        }
    }
    static hasCollision({stage, previousPosition, nextPosition, position, options}) {
        nextPosition = nextPosition || position
        previousPosition = previousPosition || position
        if(World.hasCollision({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        })) {
            return true
        }
        if(Stage.findUnitByPosition(stage, nextPosition, options)) {
            return true
        }
        return false
    }

    static hasMetCondition(stage, condition, zone) {
        if(condition == undefined
        || stage == undefined) {
            return false
        }

        if(condition.encounterKey != undefined
        && condition.encounterKey != stage.currentEncounter) {
            return false
        }

        if(condition.condition instanceof Function) {
            if(condition.condition(stage) == false) {
                return false
            }
        }
        if(condition.type == "condition") {
            return true
        }
        if(condition.type == "exit") {
            const units = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == condition.affiliation
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            const remainingUnits = units.filter((unit) => unit.isDead != true && unit.hasBeenRemoved != true)
            const removedUnits = units.filter((unit) => unit.hasBeenRemoved)
            if(removedUnits.length > 0
            && remainingUnits == 0) {
                return true
            }
            return false
        }
        if(condition.type == "defeat-unit"
        && condition.unitKey != undefined) {
            return stage.units[condition.unitKey] != undefined
                && stage.units[condition.unitKey].isDead == true
        }
        if(condition.type == "defeat-all-other-units"
        && condition.unitKey !== undefined) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.hasBeenRemoved != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return remainingUnits.length == 1
                && remainingUnits[0].key == condition.unitKey
        }
        if(condition.type == "defeat-all-units-of-type"
        && condition.unitType !== undefined) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.type == condition.unitType
                    && (unit.isDead != true && unit.hasBeenRemoved != true)
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return remainingUnits.length == 0
        }
        if(condition.type == "defeat-all-units-of-affiliation"
        && condition.affiliation !== undefined) {
            let currentZone = stage.encounters[condition.encounterKey] || zone
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == condition.affiliation
                    && (unit.isDead != true && unit.hasBeenRemoved != true)
                    && Zone.isInBounds(currentZone, unit.position)
            })
            return remainingUnits.length == 0
        }
        if(condition.type == "defeat-all-unaffiliated-units"
        && condition.affiliation !== undefined) {
            const undefeatedUnit = Objdict.find(stage.units, (unit) => {
                return unit.affiliation != condition.affiliation
                    && unit.affiliation != "none"
                    && unit.isDead != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return undefeatedUnit == undefined
        }
        if(condition.type == "wait-x-turns"
        && condition.turnNumber != undefined) {
            return stage.turn.number >= condition.turnNumber
        }
    }

    static copy(alphastage) {
        const omegastage = {
            "units": Objdict.map(alphastage.units, (unit) => Unit.copy(unit)),
            "world": alphastage.world,

            "turn": {
                "number": alphastage.turn && alphastage.turn.number || 0,
                "affiliation": alphastage.turn && alphastage.turn.affiliation,
            },
            "tags": Objdict.map(alphastage.tags || {}, (tag) => {
                return {
                    "name": tag.name,
                    "value": tag.value,
                }
            }),
            // "zone": alphastage.zone,
            // "actionMark": alphastage.actionMark, // we still using this?
            // "light": alphastage.light,
            "player": Player.copy(alphastage.player),

            "encounters": alphastage.encounters,
            "currentEncounter": alphastage.currentEncounter,
            "events": alphastage.events,

            // TO DEPRECATE, ALL OF THE BELOW:
            "conditions": alphastage.conditions,
            "success": alphastage.success,
            "failure": alphastage.failure,
            "prompt": alphastage.prompt,
            "dialogue": alphastage.dialogue && {
                "text": alphastage.dialogue.text,
                "index": alphastage.dialogue.index,
                "type": alphastage.dialogue.type,
                "speakingCharacter": alphastage.dialogue.speakingCharacter,
                "tags": Objdict.map(alphastage.dialogue.tags, (value, key) => value),
                "characters": Objdict.map(alphastage.dialogue.characters, (character) => {
                    return {
                        "tags": Objdict.map(character.tags, (value, key) => value)
                    }
                }),
            },
            "slug": alphastage.slug,
            "image": alphastage.image,
            "loopCount": alphastage.loopCount,
        }
        // TODO: suport a less embedded test stubbing for skill id gen???
        if(alphastage.idgen !== undefined) {
            omegastage.idgen = alphastage.idgen
        }
        return omegastage
    }

    //////////////
    // SCORING //
    ////////////

    // static deltascore(alphastage, omegastage, affiliation) {
    //     const TARGET_PRIORITY = {
    //         "good": 100,
    //         "bad": 100,
    //         "none": 50,
    //     }
    //     const alphascore = Stage.score(alphastage, affiliation)
    //     const omegascore = Stage.score(omegastage, affiliation)
    //     let score = alphascore - omegascore
    //     // score = Math.min(1, score / MAX_SCORE)
    //
    //     return score
    // }

    // Does not (yet) set the action.score, just returns the score.
    // Lets you pass in a different stage from action.stage for predictive logic.
    static score({action, stage, alliedAffiliation}) {
        stage = stage || action.omegastage

        const scores = {}

        // INFLUENCES //
        let influenceScore = 0
        // let influenceCount = 0
        if(action.influenceMap != undefined) {
            const omegaperformer = stage.units[action.performerKey]
            if(omegaperformer != undefined) {
                influenceScore = Stage.getInfluenceScore(action.influenceMap, omegaperformer.position)
            }
            // influenceCount += 1

            // if(omegaperformer.effects != undefined) {
            //     Objdict.forEach(omegaperformer.effects, (effect) => {
            //         if(effect.type == "trap") {
            //             effect.positions.forEach((position) => {
            //                 influenceScore += Stage.getInfluenceScore(action.influenceMap, position)
            //                 influenceCount += 1
            //             })
            //         }
            //     })
            // }
        }
        // Note well! A smaller influence percent is a better influence!!
        scores.influence = influenceScore / MAX_INFLUENCE // (MAX_INFLUENCE * influenceCount)

        // ACTION TYPE //
        scores.type = action.type

        // PROGRESS TOWARDS GOALS //
        function calculateProgressScore(units, isIncluded) {
            const status = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0, "score": 0}

            Objdict.forEach(stage.units, (unit) => {
                if(isIncluded(unit) != true) return

                status.maxhealth += unit.maxhealth
                status.health += unit.health
                status.maxhealth += unit.maxarmor || 0
                status.health += unit.armor || 0

                status.maxcount += 1
                status.count += unit.isDead || unit.deathTimer != undefined ? 0 : 1

                status.score += unit.score || 0
            })

            return {
                "count": status.count, // / status.maxcount,
                "health": status.health,  // / status.maxhealth,
                "score": status.score,
                "status": status,
            }
        }

        scores["enemy"] = calculateProgressScore(stage.units, (unit) => unit.affiliation != alliedAffiliation && unit.affiliation != "none")
        scores["ally"] = calculateProgressScore(stage.units, (unit) => unit.affiliation == alliedAffiliation && unit.affiliation != "none")
        scores["plant"] = calculateProgressScore(stage.units, (unit) => unit.type == "plant")
        scores["none"] = calculateProgressScore(stage.units, (unit) => unit.affiliation == "none")

        // All other factions are considered an enemy faction and will be targeted.
        // Do we want to eventually let factions by allies to each other? Like the
        // green faction won't target your units, but you don't control them? Then
        // we'll need a faction data set for who targets who.
        // The none faction is an exception. Is neither ally or enemy. Is this a
        // faction that is considered a lesser target? Are they still targetable
        // by a faction in the who targets who? The same might apply for other
        // factions later, like a red ai who targets your blue faction over the
        // npc green faction

        return scores
    }
    static getInfluenceScore(influenceMap, position) {
        return influenceMap[position.x + "x" + position.y]
    }
    static flattenActionMap(actionmap) {
        let actions = []
        Objdict.forEach(actionmap, (actionmaplist) => {
            actions = actions.concat(actionmaplist)
        })
        return actions
        // // By flattening a unit's action map, each possible position
        // // will have one and only one action, scored as the "best."
        // // In most cases, this is just different directions of approaching
        // // that same action type from different previous positions.
        // return Objdict.map(actionmap, (actionmaplist) => {
        //     return actionmaplist[0]
        // })
    }
    // Stage.isBetterScore(a, b)
    // returns true if (a) is a better score than (b)
    static isBetterScore(a, b, unit) {
        // if(a.ally.score < b.ally.score) return true
        // if(a.ally.score > b.ally.score) return false

        if(a.enemy.count < b.enemy.count) return true
        if(a.enemy.count > b.enemy.count) return false
        if(a.enemy.health < b.enemy.health) return true
        if(a.enemy.health > b.enemy.health) return false

        if(unit.state != "idle") {
            if(a.influence > b.influence) return true
            if(a.influence < b.influence) return false
        }

        if(a.ally.count > b.ally.count) return true
        if(a.ally.count < b.ally.count) return false
        if(a.ally.health > b.ally.health) return true
        if(a.ally.health < b.ally.health) return false

        // if(a.none != undefined && b.none != undefined) {
        //     if(a.none.count < b.none.count) return true
        //     if(a.none.count > b.none.count) return false
        //     if(a.none.health < b.none.health) return true
        //     if(a.none.health > b.none.health) return false
        // }

        // if(a.none ? a.none.count : 0 < b.none ? b.none.count : 0) return true
        // if(a.none ? a.none.count : 0 > b.none ? b.none.count : 0) return false

        const types = ["invoke skill", "move", "wait"]
        if(types.indexOf(a.type) > types.indexOf(b.type)) return true
        if(types.indexOf(a.type) < types.indexOf(b.type)) return false
        // scores.byActionType = 0
        // if(action.type == "move through") {
        //     scores.byActionType = -1 // to be skipped!!
        // } else if(action.type == "invoke skill") {
        //     scores.byActionType = 1
        // } else if(action.type == "move") {
        //     scores.byActionType = 2
        // }

        if(a.distance < b.distance) return -1
        if(a.distance > b.distance) return +1

        // TODO: filter out a and b for .type == -1?
        // or just leave that to a separate isInvalidAction?
    }
    static isInvalidAction(action) {
        // TODO: why do we even keep these invalid actions around?
        if(action.type == "move through") {
            return true
        }
    }

    ////////////////
    // NEXT TURN //
    //////////////

    static calculateNextTurn(stage, options = {}) {
        const {aiActions, steps} = Stage.getNonPlayerSteps(stage, options)

        stage.nextTurn = {
            "aiActions": aiActions,
            "steps": steps,
            "omegastage": steps[steps.length - 1].omegastage
        }
    }
    static getNonPlayerSteps(stage, options = {}) {
        let steps = []

        // // HEY!! WHY ISN'T THIS DOUBLED FOR THE OTHER END OF TURN???
        // steps = steps.concat(Stage.getEndOfTurnTileSteps(stage))
        // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEnergyRefresh(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        if(stage.encounters[stage.currentEncounter || 1] != undefined
        && stage.encounters[stage.currentEncounter || 1].conditions != undefined) {
            const encounter = stage.encounters[stage.currentEncounter || 1]
            encounter.conditions.forEach((condition) => {
                if(Stage.hasMetCondition(stage, condition, encounter.zone)) {
                    if(condition.events != undefined) {
                        steps = steps.concat(Stage.processEventSteps(stage, condition.events))
                        stage = steps[steps.length-1]?.omegastage || stage
                    }
                }
            })
            if(encounter != stage.encounters[stage.currentEncounter || 1]) {
                return {steps}
            }
            // // if has moved to new encounter
            // const nextEncounter = stage.encounters[stage.currentEncounter || 1]
            // if(encounter != nextEncounter) {
            //     steps = steps.concat(Stage.getEventSteps(stage, "turn:0:start"))
            //     stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            //     return {steps}
            // }
        }

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-even:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getStartTurnSteps("bad", stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getStartOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-odd:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        let aiActions = []
        const aiAffiliations = ["bad", "neutral"]
        if(options.ignoreAI != true) {
            aiAffiliations.forEach((affiliation) => {
                const ai = Stage.getAiSteps(affiliation, stage)
                aiActions = aiActions.concat(ai.actions) // for returning from this function
                steps = steps.concat(ai.steps)
                stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            })
        }

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-odd:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEnergyRefresh(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        if(stage.encounters[stage.currentEncounter || 1] != undefined
        && stage.encounters[stage.currentEncounter || 1].conditions != undefined) {
            const encounter = stage.encounters[stage.currentEncounter || 1]
            encounter.conditions.forEach((condition) => {
                if(Stage.hasMetCondition(stage, condition, encounter.zone)) {
                    if(condition.events != undefined) {
                        steps = steps.concat(Stage.processEventSteps(stage, condition.events))
                        stage = steps[steps.length-1]?.omegastage || stage
                    }
                }
            })
            if(encounter != stage.encounters[stage.currentEncounter || 1]) {
                return {steps, aiActions}
            }
        }
        // if(stage.conditions != undefined) {
        //     stage.conditions.forEach((condition) => {
        //         if(Stage.hasMetCondition(stage, condition)) {
        //             steps = steps.concat(Stage.processEventSteps(stage, condition.events))
        //             stage = steps[steps.length-1]?.omegastage || stage
        //         }
        //     })
        //     if(stage.isDone == true) {
        //         return {steps, aiActions}
        //     }
        // }

        steps = steps.concat(Stage.getStartTurnSteps("good", stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getStartOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-even:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        // DECREASE EFFECT DURATION

        // actions = actions.concat(Stage.getEventActions(this.events[(this.turn.number + 2) + ":start"]))
        // actions = actions.concat(Stage.getWorldActions("good", shadowunits))

        return {steps, aiActions}
    }
    static getEnergyRefresh(stage) {
        return [
            Step.instantiate({
                "type": "refresh",
                "alphastage": stage,
                "deltastages": [
                    {
                        "units": Objdict.map(stage.units, (unit) => {
                            return {
                                "energy": {"move": true, "invoke skill": true, "1": true, "2": true},
                            }
                        })
                    }
                ]
            })
        ]
    }
    static getStartTurnSteps(affiliation, stage) {
        const steps = [
            Step.instantiate({
                "type": "turn start",
                "affiliation": affiliation,
                "message": affiliation == "bad" ? "ENEMY TURN" : "YOUR TURN",
                "alphastage": stage,
                "deltastages": []
            }),
        ]
        steps.push(Step.instantiate({
            "type": "refresh",
            "alphastage": stage,
            "deltastages": [
                {
                    "turn": {
                        "number": stage.turn.number + 1,
                        "affiliation": affiliation,
                    },
                }
            ]
        }))
        return steps
    }
    static getEndOfTurnTileSteps(stage) {
        const steps = []
        let alphastage = stage
        // if(stage.success != undefined
        // && stage.success.condition == "escape") {
        //     stage.success.positions.forEach((position) => {
        //         Objdict.forEach(alphastage.units, (unit) => {
        //             if(unit.isDead != true
        //             && Geometry.equals(unit.position, position)
        //             && unit.affiliation == stage.success.affiliation) {
        //                 const step = Step.instantiate({
        //                     "type": "escape",
        //                     "alphastage": alphastage,
        //                     "deltastages": [{
        //                         "annotation": {"type": "escape", "startPosition": unit.position},
        //                         "units": {
        //                             [unit.key]: {
        //                                 "isDead": true,
        //                                 "hasBeenRemoved": true,
        //                             }
        //                         }
        //                     }]
        //                 })
        //
        //                 alphastage = step.omegastage
        //                 steps.push(step)
        //             }
        //         })
        //     })
        // }
        return steps
    }
    static getStartOfTurnSkillSteps(stage, options = {}) {
        let steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Objdict.forEach(stage.units, (unit) => {
            const alphaunit = alphastage.units[unit.key]
            if(alphaunit.isDead == true) return
            if(alphaunit.hasBeenRemoved == true) return
            Objdict.forEach(alphaunit.skills, (skillKey) => {
                const skill = skills.get(skillKey)
                if(skill != undefined) {
                    if(skill.type == "at-start-of-turn"
                    || (skill.type == "at-start-of-my-turn" && alphastage.turn.affiliation == alphaunit.affiliation)
                    || (skill.type == "at-start-of-player-turn" && alphastage.turn.affiliation == "good")) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            if(skill.calculateStep instanceof Function) {
                                const step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "stage": alphastage,
                                })

                                alphastage = step.omegastage
                                steps.push(step)
                            }
                        }
                    }
                }
            })
        })

        steps = steps.concat(Reactions.getSteps(alphastage))

        return steps
    }
    static getEndOfTurnSkillSteps(stage, options = {}) {
        let steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Objdict.forEach(stage.units, (unit) => {
            const alphaunit = alphastage.units[unit.key]
            if(alphaunit.isDead == true) return
            if(alphaunit.hasBeenRemoved == true) return
            Objdict.forEach(unit.effects, (effect, effectKey) => {
                const alphaeffect = alphaunit.effects[effectKey]
                if(alphaeffect.timer != undefined) {
                    if(alphaeffect.timer - 1 <= 0) {
                        // if(alphaeffect.type == "fuse"
                        // && alphaeffect.skillKey != undefined
                        // && skills.get(alphaeffect.skillKey) != undefined) {
                        //     const step = skills.get(alphaeffect.skillKey).calculateStep({
                        //         "performerKey": alphaunit.key,
                        //         "effectKey": effectKey,
                        //         "position": alphaunit.position,
                        //         "stage": alphastage,
                        //     })
                        //     step.skillKey = alphaeffect.skillKey
                        //     step.type = "invoke skill"
                        //
                        //     Objdict.forEach(step.omegastage.units, (unit) => {
                        //         if(unit.health <= 0
                        //         && unit.isDead != true) {
                        //             Step.add(step, {"units": {[unit.key]: {"isDead": true}}})
                        //         }
                        //     })
                        //
                        //     alphastage = step.omegastage
                        //     steps.push(step)
                        // } else {
                        const step = Step.instantiate({
                            "type": "remove effect",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: undefined
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    } else {
                        const step = Step.instantiate({
                            "type": "decrement effect timer",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: { // TODO: why isn't alphaeffect.key not defined :<
                                                "timer": alphaeffect.timer - 1,
                                            }
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    }
                }

                // // this doesn't work, for whatever reason.
                // // just going to do something different.
                if(alphaeffect.type == "at-end-of-turn"
                && alphaeffect.skillKey != undefined) {
                    const skill = skills.get(alphaeffect.skillKey)
                    if(skill != undefined) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            if(skill.calculateDeltastages instanceof Function) {
                                const step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": alphaeffect.skillKey, // wait do i still need to do this? i don't think we do.
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key, // wait, you're performing it on yourself? because it's your effect?
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "position": alphaunit.position,
                                    "stage": alphastage,
                                })
                            }

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
            Objdict.forEach(alphaunit.skills, (skillKey) => {
                const skill = skills.get(skillKey)
                if(skill != undefined) {
                // && (alphastage.turn.number + (options.turnNumber || 0)) % 2 == 1) {
                // && (alphaunit.affiliation == "good" && alphastage.turn.number % 2 == 0
                // || alphaunit.affiliation == "bad" && alphastage.turn.number % 2 != 0)) {
                    if(skill.type == "at-end-of-turn"
                    || (skill.type == "at-end-of-my-turn" && alphastage.turn.affiliation == alphaunit.affiliation)
                    || (skill.type == "at-end-of-player-turn" && alphastage.turn.affiliation == "good")) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            let step = undefined
                            if(skill.calculateDeltastages instanceof Function) {
                                step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": skillKey, // I hate this
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key,
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "stage": alphastage,
                                })
                            }

                            // TODO: this is making a step & animation
                            // for every unitzone that has this skill.
                            // can we return undefined if there is
                            // no step to be performed?

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
        })

        // deaths and stuff:
        steps = steps.concat(Reactions.getSteps(alphastage))
        if(steps.length > 0) {
            alphastage = steps[steps.length-1].omegastage
        }

        return steps
    }

    static getAiSteps(affiliation, stage) {
        const turn = {
            "steps": [],
            "actions": {} // by unit key
        }

        const units = []
        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation == affiliation
            && unit.isDead != true
            && Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, unit.position)) {
                units.push(unit)
            }
        })

        let alphastage = stage
        units.forEach((unit) => {
            const actionmap = Unit.calculateActions(unit.key, alphastage) // we really recalculating this huh
            let actions = Stage.flattenActionMap(actionmap)

            if(actions.length == 0) return

            actions.sort((a, b) => {
                if(a.distance < b.distance) return -1
                if(a.distance > b.distance) return +1
                return 0
            })

            let bestAction = undefined
            actions.forEach((action) => {
                if(Stage.isInvalidAction(action)) {
                    return action
                }

                // TODO: This should be far less verbose... Pull in the Step.js class?? as Sequence.js?
                // action.predictiveSteps = action.steps.concat(Stage.getEndOfTurnSkillSteps(action.omegastage))
                // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage
                // // action.predictiveSteps = action.predictiveSteps.concat(Stage.getEndOfTurnSkillSteps(action.predictiveOmegastage, {"turnNumber": +1}))
                // // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage

                action.score = Stage.score({
                    "stage": action.omegastage,
                    // "stage": action.predictiveOmegastage, // ADDED FOR BOMBER
                    "action": action,
                    "alliedAffiliation": affiliation,
                    "unit": unit,
                })

                if(action.type == "move through") {
                    return
                }

                if(bestAction == undefined
                || Stage.isBetterScore(action.score, bestAction.score, unit)) {
                    bestAction = action
                }
            })
            if(bestAction != undefined) {
                turn.actions[unit.key] = {"action": bestAction, "actionmap": actionmap}
                turn.steps = turn.steps.concat(bestAction.steps)
                alphastage = turn.steps[turn.steps.length-1].omegastage
            }
        })

        return turn

        // TODO: Address the hangover of returning actions alongside steps.
        // We need them to render the enemy ui. We really just use action type
        // and action position. We are currently hurting because we're not
        // returning the entire action map (to show enemy range). We need to
        // eventually include order of actions as well, to match the order
        // of steps, so we can maybe animate the enemy intention ui with some
        // slight order-of-operations delay in how it renders out.

        // RECENT //

        // const affiliatedUnits = {}
        // let steps = []
        // let alphastage = stage
        // Objdict.forEach(stage.units, (unit) => {
        //     const alphaunit = alphastage.units[unit.key]
        //     if(alphaunit.affiliation == "bad"
        //     && alphaunit.isDead != true) {
        //         const actionmap = Unit.calculateActions(unit.key, alphastage)
        //         const action = Unit.getBestAction(actionmap)
        //         steps = steps.concat(action.steps)
        //         affiliatedUnits[unit.key] = {action, actionmap}
        //
        //         if(action != undefined) {
        //             alphastage = action.omegastage
        //         }
        //     }
        // })
        // // TODO: ONCe WE HAVE THE BEST ACTION, WE CAN PROBABLY DUMP ALLLLL THE OTHER POSSIBILITIES AS USELESS.
        // return {"affiliatedUnits": affiliatedUnits, "affiliatedSteps": steps}

        // OLDER //

        // this.influence[affiliation] = this.getInfluence(affiliation, shadowunits)
        // TODO: uuuuh if there is any meaningful state change in stage vs
        // alphastagewithheavycomputation, then we need to recompute here.

        // // this is so wasteful, given that
        // // alphastage at the start of this getnonplyaeractions process should have already
        // // computed all of this. or most of this (it doesn't have the start of turn state
        // // changes like effects wearing off)
        // // UUH IS THIS STILL TRUE I REFACTORED IT SO IT ONLY CALCULATES ONCE
        //
        // Objdict.forEach(stage.units, (unit) => {
        //     if(unit.affiliation == affiliation && unit.isDead != true) {
        //         steps = steps.concat(unit.bestAction.steps)
        //         // THIS DOES NOT RESPECT THE ORDER OF THE
        //         // BEST ACTIONS, SO IF YOU EVER CHANGE IT
        //         // SO UNIT ORDER IS DYNAMIC, THIS MUST BE
        //         // RESTRUCTURED ACCORDINGLY
        //     }
        // })
    }
    static getEventSteps(stage, eventKey) {
        let events = []

        if(stage == undefined) {
        // || stage.encounters == undefined
        // || stage.encounters[stage.currentEncounter || 1] == undefined) {
            return events
        }

        // If there is an ink knot by this name, we'll run it!!
        // console.log(stage.slug + "_encounter" + (stage.currentEncounter || 1) + "_" + eventKey.replaceAll(":", ""))
        events = events.concat(Stage.processEventSteps(stage, [
            InkDialogue("chapter" + stage.slug + "_encounter" + (stage.currentEncounter || 1) + "_" + eventKey.replaceAll(":", ""), stage)
        ]))

        const encounter = stage.encounters[stage.currentEncounter || 1]
        if(encounter != undefined) {
            if(encounter.conditions != undefined) {
                const condition = encounter.conditions.find((condition) => condition.type == eventKey)
                if(condition != undefined) {
                    events = events.concat(Stage.processEventSteps(stage, condition.events))
                }
            }

            if(encounter.events != undefined
            && encounter.events[eventKey] != undefined) {
                events = events.concat(Stage.processEventSteps(stage, encounter.events[eventKey]))
            }
        }

        if(stage.events != undefined) {
            events = events.concat(Stage.processEventSteps(stage, stage.events))
        }

        return events
    }
    // accepts: an array of either events or subarrays of events.
    // outputs: an new array of all events
    static flattenEventSteps(events) {
        let output = []
        events.forEach((event) => {
            if(event instanceof Array) {
                output = output.concat(Stage.flattenEventSteps(event))
            } else {
                output.push(event)
            }
        })
        return output
    }
    // inputs in an array of steps.
    // you can embed those steps in subarrays.
    // you can return those steps from jit functions (passed the stage).
    // you can also calculate the entire top-level array using a jit function.
    static processEventSteps(alphastage, inputs) {
        let steps = []


        if(inputs == undefined) return []
        if(inputs instanceof Function) {
            inputs = inputs(alphastage)
        }
        if(inputs instanceof Array != true) {
            inputs = [inputs]
        }
        inputs.forEach((input) => {
            if(input instanceof Function) {
                input = input(alphastage)
            }
            if(input == undefined) {
                return undefined
            }
            if(input instanceof Array == false) {
                input = new Array(input)
            }
            // TODO: Make this recursive for functions and arrays all the way down!!
            input = Stage.flattenEventSteps(input)

            input.forEach((step) => {
                if(step == undefined) return

                step = Step.copy(step)

                step.alphastage = alphastage
                step = Step.instantiate(step)
                alphastage = step.omegastage

                steps.push(step)
            })
        })

        return steps
    }

    ////////////////
    // YOUR TURN //
    //////////////

    static calculateActions(stage, {force} = {}) {
        const mark = Speedtest.mark("Actions", "Stage.calculateActions")

        if(stage.hasPerformedActionCalculation == true && force != true) {
            return
        }

        Objdict.forEach(stage.units, (unit) => {
            if(Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, unit.position)) {
                if(unit.affiliation == "good") {
                    unit.actionmap = Unit.calculateActions(unit.key, stage)
                }
                // DEUBG: We're not calculating it for all units, depending on affiliation.
                // if(unit.affiliation == "good") {
                //     unit.actionmap = Unit.calculateActions(unit.key, stage)
                    // DEBUG // We're now calculating this just-in-time for when you hover over this actionmap option.
                    // Object.values(unit.actionmap).forEach((actionlist) => actionlist.forEach((action) => {
                    //     Stage.calculateNextTurn(action.omegastage)
                    // }))
                // }
            }
        })
        // // We're removing this and only calculating these just before you end your turn.
        // Stage.calculateNextTurn(stage) // DEBUG

        stage.hasPerformedActionCalculation = true
        Stage.calculateLight(stage)

        mark()

        return stage
    }
    static calculateLight(stage) {
        stage.light = {}
        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation != "bad") return
            if(unit.type == "zone") return

            let actionmap = unit.actionmap
            // if(stage.nextTurn != undefined
            // && stage.nextTurn.aiActions != undefined
            // && stage.nextTurn.aiActions[unit.key] != undefined
            // && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            //     actionmap = stage.nextTurn.aiActions[unit.key].actionmap
            // }
            // if(actionmap == undefined) return

            Objdict.forEach(actionmap, (actionlist, positionKey) => {
                // const action = Selection.findActionInActionlistToActuallyUse({unit, actionlist, "options": {"ignoreActiveSkill": true}})
                // if(action == undefined) return
                stage.light[positionKey] = true // action.position
            })
        })
    }

    static getScore(stage) {
        let score = undefined
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == "good"
            && unit.score != undefined) {
                score = score || 0
                if(unit.isDead != true
                && unit.hasBeenRemoved != true) {
                    score += unit.score
                }
            }
        })
        return score
    }

    static findEncounterAtPosition(stage, position) {
        return Objdict.find(stage.encounters, (encounter, encounterSlug) => {
            return Zone.isInBounds(encounter.zone, position)
        })
    }

    static addUnit(stage, unit) {
        stage.units[unit.key] = unit
    }
    static addItemToInventory(stage, item) {
        item = Stage.readyItemForInventory(stage.player.inventory, item)
        stage.player.inventory.items[item.key] = item
    }
    static readyItemForInventory(inventory, newItem) {
        if(newItem.class == undefined) throw new Error("Item must have a class.")
        newItem.amount = newItem.amount || 1

        const items = Object.values(inventory.items).sort((a, b) => a.slot - b.slot)
        const oldItem = items.find((oldItem) => oldItem.class == newItem.class)
        if(oldItem != undefined) {
            newItem.key = oldItem.key
            newItem.slot = oldItem.slot
            newItem.amount += oldItem.amount || 0
        }

        if(oldItem == undefined) {
            newItem.key = newItem.key || shortid.generate()
            newItem.slot = 10
            for(let slot = 0; slot < 10; slot += 1) {
                let slotItem = items.find((item) => item.slot == slot)
                if(slotItem == undefined) {
                    newItem.slot = slot
                    break
                }
            }
        }

        return newItem
    }
}

// const directions = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
// // TODO: merge this with utilities/Directions.js? Pull them from Geometry.north/etc?
//

class Player {
    static copy(alphaplayer) {
        if(alphaplayer == undefined) return undefined
        return {
            "score": alphaplayer.score,
            "affiliation": alphaplayer.affiliation,
            "perks": alphaplayer.perks && Object.values(alphaplayer.perks),
            "inventory": alphaplayer.inventory && {
                "gold": alphaplayer.inventory.gold,
                "items": Objdict.map(alphaplayer.inventory.items, (item) => {
                    const copiedItem = {}
                    for(let key in item) {
                        if(item[key] != undefined) {
                            copiedItem[key] = item[key]
                        }
                    }
                    return copiedItem
                })
            },
            "party": {
                "units": Objdict.map(alphaplayer.party.units, (unit) => unit)
            }
        }
    }
}
